var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8 3.4h-2.1V0h-3.4v3.4H10.7V0H7.2v3.4h-2C2.3 3.4 0 5.8 0 8.6v30.2C0 41.7 2.3 44 5.2 44h33.7c2.8 0 5.2-2.3 5.2-5.2V8.6c-.1-2.8-2.4-5.2-5.3-5.2zm1.8 35.4c0 .9-.8 1.7-1.7 1.7H5.2c-.9 0-1.7-.8-1.7-1.7V16.2h37.1v22.6zm0-26.1H3.4V8.6c0-.9.8-1.7 1.7-1.7h2.1v3.4h3.4V6.9h22.7v3.4h3.4V6.9h2.1c.9 0 1.7.8 1.7 1.7v4.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 19.8h3.4v3.4H6.5zM13.4 19.8h3.4v3.4h-3.4zM20.3 19.8h3.4v3.4h-3.4zM27.2 19.8h3.4v3.4h-3.4zM34 19.8h3.4v3.4H34zM6.5 26.6h3.4V30H6.5zM13.4 26.6h3.4V30h-3.4zM20.3 26.6h3.4V30h-3.4zM27.2 26.6h3.4V30h-3.4zM6.5 33.5h3.4v3.4H6.5zM13.4 33.5h3.4v3.4h-3.4zM20.3 33.5h3.4v3.4h-3.4zM27.2 33.5h3.4v3.4h-3.4zM34 26.6h3.4V30H34z"
  })));
}

export default SvgCalendar;